import { cn } from '@/utils/utils';
import { Button } from '../common/Button';

interface ModalFooterProps {
    footerClassName?: string,
    cancelButton?: React.ReactNode,
    cancelButtonClassName?: string,
    onCancel?: Function,
    saveButton?: React.ReactNode,
    saveButtonClassName?: string,
    onSave?: Function
}

export default function ModalFooter({
    cancelButton,
    cancelButtonClassName,
    onCancel,
    saveButton,
    saveButtonClassName,
    onSave
}: ModalFooterProps) {
    return (
        <>
            {
                cancelButton && (
                    <Button
                        variant='outline'
                        className={cn('w-[166.5px] text-[15px] font-semibold h-12 hover:text-text-black-1 border border-border-button text-text-black-1 !rounded-[10px]', cancelButtonClassName)}
                        onClick={() => onCancel?.()}
                    >
                        {cancelButton}
                    </Button>
                )
            }
            {
                saveButton && (
                    <Button
                        variant='active'
                        className={cn('w-[166.5px] text-[15px] font-semibold h-12 bg-active hover:opacity-80 hover:text-white transition-opacity duration-300 !rounded-[10px]', saveButtonClassName)}
                        onClick={() => onSave?.()}
                    >
                        {saveButton}
                    </Button>
                )
            }
        </>
    );
}
